import { Component, Inject } from '@angular/core';
import { StateService } from "@uirouter/angular";
import { CVCompetenceTypesService } from "../../core/cvcompetencetypes.dataservice";
import { MatDialog } from "@angular/material/dialog";
import { DetailsBase } from "../shared/details.base";
import * as modes from "./modes";

@Component({
    selector: "crew-cvcompetencetype",
    template: require('./cv-competence-type.component.html')
})
export class CvCompetenceType extends DetailsBase<Nema.Crew.Model.CompetenceTypeCVMapping> {

    constructor(
        stateService: StateService,
        dialog: MatDialog,
        @Inject('cvCompetenceType') cvCompetenceTypeEntity: Nema.Crew.Model.CompetenceTypeCVMapping,
        @Inject("cvCompetenceGroups") public cvCompetenceGroups: Nema.Crew.Model.CVCompetenceGroup[],
        @Inject("competenceGroups") public competenceGroups: Nema.Crew.Model.CompetenceGroup[],
        @Inject("competenceTypes") public competenceTypes: Nema.Crew.Model.CompetenceType[],
        @Inject(CVCompetenceTypesService.Id) cvCompetenceTypesService: CVCompetenceTypesService,
        @Inject('$log') $log: ng.ILogService) {

        super(stateService, dialog, cvCompetenceTypeEntity, cvCompetenceTypesService, $log);

        (<any>this.entity.CompetenceTypeCVMappingCompetenceGroups).load();
        (<any>this.entity.CompetenceTypeCVMappingCompetenceTypes).load();
    }

    public entityName = "CV Competence";

    public editStateName = "app.settings.cvcompetencetypes.edit";

    public listStateName = "app.settings.cvcompetencetypes";

    public namingModes = modes.namingModes;

    public inclusionModes = modes.inclusionModes;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/cvcompetencetypes/cv-competence-type.component.ts